import React from 'react';

export const TagTableColumn = (props) => {
    const {
        CustomData,
        Value,
        AddToSearch:addToSearch = (text) => {}
    } = props;
    
    if(!Value) {
        return null;
    }

    return <div className="tag-container">
        {
            Value.map(x => (
                <span className="file-tag"
                  onClick={() => addToSearch(x.Tag.shortName)}
                      key={x.fileUploadTagId}
                >
                    {x.Tag.shortName}
                </span>
            ))
        }
    </div>;
};
